import { render, staticRenderFns } from "./caseHeads.vue?vue&type=template&id=3f9f85ac&scoped=true"
import script from "./caseHeads.vue?vue&type=script&lang=js"
export * from "./caseHeads.vue?vue&type=script&lang=js"
import style0 from "./caseHeads.vue?vue&type=style&index=0&id=3f9f85ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9f85ac",
  null
  
)

export default component.exports